import { z } from 'zod';

export const RefSkills = z.object({
  code: z.string(),
  referential_id: z.string().uuid(),
  macro_skill_code: z.string().nullish(),
  name: z.string(),
  type: z.string().nullish(),
  environmental_transition: z.boolean(),
  digital_transition: z.boolean(),
  riasec_major: z.string(),
  riasec_minor: z.string(),
  ogr_code: z.number().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type RefSkillsT = z.infer<typeof RefSkills>;

export const RefSkillsInsert = RefSkills.partial();

export type RefSkillsInsertT = z.infer<typeof RefSkillsInsert>;

export const RefSkillsUpdate = RefSkills.partial();

export type RefSkillsUpdateT = z.infer<typeof RefSkillsUpdate>;
